import { Button, Tooltip } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export interface EditButtonProps {
  onClick: () => void;
}

export const EditButton = (props: EditButtonProps) => {
  const { onClick } = props;
  const { t } = useTranslation(['common']);

  return (
    <Tooltip
      label={t('buttons.edit', {
        ns: 'common',
        defaultValue: 'Edit',
      })}
    >
      <Button variant="light" size="xs" onClick={onClick}>
        <IconPencil size={14} />
      </Button>
    </Tooltip>
  );
};
